// src/App.js
import './global.scss';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

import { ThemeProvider } from '@mui/material';
import React, { Suspense, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { pdfjs } from 'react-pdf';
import { Provider, useSelector } from 'react-redux';
import { Router } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { PersistGate } from 'redux-persist/integration/react';

import getRouteConfigs from './app/router/config/base.routes';
import generateRoutesFromConfig from './app/router/utils/generateRoutesFromConfig';
import history from './app/router/utils/history';
import store, { persistor } from './redux/store/index';
import { theme } from './theme';

// Configure PDF.js worker
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

const Main = () => {
  const { i18n } = useTranslation();
  const { currentLanguage } = useSelector((state) => state.auth);

  useEffect(() => {
    i18n.changeLanguage(currentLanguage?.code);
  }, [currentLanguage]);

  const configs = useMemo(getRouteConfigs, []);

  return useMemo(() => generateRoutesFromConfig(configs), [configs]);
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <Router history={history}>
            <Suspense fallback={<div>Loading...</div>}>
              <Main />
            </Suspense>
          </Router>
        </PersistGate>
      </Provider>
      <ToastContainer position="top-right" autoClose={3000} />
    </ThemeProvider>
  );
}

export default App;
